<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { getDoctorInformation } from "@/api";
import util from "./utils";
export default {
  mounted() {
    // 提交sdk连接请求
    // this.$store.dispatch("connect");
    // this.$store.dispatch("updateRefreshState");
    // const token = localStorage.getItem("user_token");
    // token && this.getDoctorInformation();
  },
  watch: {
    systemInfo(curVal, oldVal) {
      console.log(curVal, "监听消息");
      let content = JSON.parse(curVal.content);
      if (content.custom_type === "prescriptionDone") {
        // this.$message({
        //   message: content.msg,
        //   type: "success",
        // });
        this.open(content);
      }
    },
  },
  methods: {
    open(content) {
      this.$confirm(content.msg, "提示", {
        confirmButtonText: "查看",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push("/index/user/reportManage");
      });
      // .catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '取消查看'
      //   });
      // });
    },

    async getDoctorInformation() {
      const { code, data } = await getDoctorInformation();
      if (code === 1) {
        this.$store.commit("setStatus", data.status);
        util.setStore("userInfo", data);
      }
    },
  },
  computed: {
    systemInfo() {
      return this.$store.state.systemInfo;
    },
  },
};
</script>
<style>
.textCenter {
  text-align: center;
}

/** 视频播放窗口 */
#local .nertc-video-container {
  width: 100% !important;
  height: 100% !important;
}
#local .nertc-video-container video {
  width: 90%;
  height: 90%;
  object-fit: cover;
}
#remote .nertc-video-container {
  width: 100% !important;
  height: 100% !important;
}
#remote .nertc-video-container video {
  /* width: 90% !important;
  height: 90% !important; */
  object-fit: cover;
}

.customBtn {
  width: 40%;
}
.emptyDataCenter {
  display: flex;
  justify-content: center;
  align-content: center;
}
.el-page-header__title {
  font-size: 17px !important;
}
.el-icon-loading {
  font-size: 50px !important;
}
/*
	*这里是当表单没有数据的统一显示图片
	*/
.el-table__empty-text {
  display: block;
  width: 200px;
  /* height: 200px; */
  /* padding-top: 150px; */
  /* margin: 230px; */
  /* background: url("./assets/images/empty.png") no-repeat !important; */
  color: #909399;
  box-sizing: border-box;
}

/* 修改加载进度条 */
#nprogress .bar {
  background: white !important;
  height: 3px !important;
}

/* 修改加载进度条 */
#nprogress .spinner-icon {
  border-top-color: white;
  border-left-color: white;
}
.min_height_crad400 {
  min-height: 800px !important;
}

.status_card {
  /* float: right;
  margin-bottom: 50px; */
  width: 20%;
  position: fixed;
  top: 90px;
  right: 40px;
  padding-top: 20px;
}
.prescription_type {
  width: 100px;
  text-align: center;
  /* margin: 20px; */
}
.record_num {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: calc(50% - 70px);
  color: #fc701a;
  background: url("./assets/images/icon1.png") 0 center no-repeat;
  font-size: 13px;
  padding-left: 15px;
}

/* .el-button--primary {
  color: #fff;
  background-color: #fc701a !important;
  border-color: #fc701a !important;
} */
.emptyDataCenter {
  padding: 20% 0 20% 0;
}
.netcall .el-card__body {
  padding: 0 !important;
}
</style>
